import "./App.css";
import {Routes,Route, useNavigate} from "react-router-dom";
import MinHome from "./pages/MiniWebsite/Home";
import Contact from "./pages/Contact";
import Contactlogin from "./pages/Contact-login";
import About from "./pages/About";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import Productdetails from "./pages/Productdetails";
import Category from "./pages/Category";
import Myaccount from "./pages/Myaccount";
import Profile from "./pages/profilepage/Profile";
import OrderHistoryDetails from "./pages/OrderHistoryDetails";
import Credit from "./pages/Credit";
import OrderHistorytwo from "./pages/OrderHistorytwo";
import Productdetailstwo from "./pages/Productdetailstwo";
import Thankyoupage from "./pages/Thankyoupage";
import Termsconditions from "./pages/Termsconditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Categoryforbrand from "./pages/Category-for-brand";
import MiniCategory from "./pages/MiniWebsite/CategoryMini";
import Categoryforsearch from "./pages/Category-for-search";
import Thankyoupagelogin from "./pages/Thankyoupagelogin";
import Voucherrequest from "./pages/Voucherrequest";
import Useragreement from "./pages/Useragreement";
import Voucherrequestlist from "./pages/Voucherrequestlist";
import Creditrequestlist from "./pages/Creditrequestlist";
import Creditrequest from "./pages/Creditrequest";
import Mycredit from "./pages/Mycredit";
import Changeyourpassword from "./pages/Changeyourpassword";
import Theam from "./pages/theam/Theam";
import OrderRequest from "./pages/Order_Request/OrderRequest";
import RedirectionComp from "./components/RedirectionComp";
import BulkProductdetails from "./pages/MiniWebsite/Productdetails";

import { useEffect } from "react";
import axios from "axios";
import { bulk, tokenstore } from "./Localstorage/Store";
import Error from "./pages/Error/Error";
import SaveCartList from "./pages/SaveCart/SaveCartList";
import SavedCartDetails from "./pages/SaveCartDetail/SavedCartDetails";
import SaveCartPay from "./pages/SaveCartPay/SaveCartPay";



function App() {
  const nvg = useNavigate()

  const getkey = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get("key"); 
    if (key) {
      try {
        const Tokendata = { key: key };
        let url = `${process.env.REACT_APP_API_URL}bulk_product/get-token/`;
        const response = await axios.post(url, Tokendata);
        
        const correctedData = response.data.token
          .replace(/'/g, '"')          
          .replace(/True/g, 'true')    
          .replace(/False/g, 'false'); 
        
        let tokenData = JSON.parse(correctedData);
        tokenstore(tokenData)
        bulk(false);
        nvg('/home');
      } catch (error) {
        console.error("Error processing token:", error);
      }

    }
  
  };

  useEffect(()=>{
    getkey();
      },[])

  return (
    <div className="App">
      <Routes >
        <Route path="/" element={<Error />} />
        <Route path="/home" element={<RedirectionComp page={<MinHome />} />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/contactlogin" element={<RedirectionComp page={<Contactlogin />} />} />
        <Route path="/about" element={<About />} />
        <Route path="/mycredit" element={<Mycredit />} />
        <Route path="/creditrequest" element={<Creditrequestlist />} />
        <Route path="/addcreditrequest" element={<Creditrequest />} />
        <Route path="/cart" element={<RedirectionComp page={<Cart />} />} />
        <Route path="/wishlist" element={<RedirectionComp page={<Wishlist />} />} />
        <Route path="/checkout/" element={<RedirectionComp page={<Checkout />} />} />
        <Route path="/myaccount" element={<RedirectionComp page={<Myaccount />} />}  />
        <Route path="/productdetails" element={<RedirectionComp page={<Productdetails />} />}  />
        <Route path="/productdetailstwo" element={<RedirectionComp page={<Productdetailstwo />} />}  />
        <Route path="/category/:id/:name/:url" element={<RedirectionComp page={<MiniCategory />} />}  />
        <Route path="/categoryforbrand/:name" element={<RedirectionComp page={<Categoryforbrand />} />}  />
        <Route path="/categoryforsearch/:name" element={<RedirectionComp page={<Categoryforsearch />} />}  />
        <Route path="/profile" element={<RedirectionComp page={<Profile/>}/>} />
        <Route path="/theam" element={<RedirectionComp page={<Theam />} />} />
        <Route path="/order-history-detail/:orderid" element={<RedirectionComp page={<OrderHistoryDetails />} />} />
        <Route path="/order-history" element={<RedirectionComp page={<OrderHistorytwo />} />} />
        <Route path="/order-request/:orderid" element={<RedirectionComp page={<OrderRequest />} />} />
        <Route path="/changeyourpassword" element={<RedirectionComp page={<Changeyourpassword />} />} />
        <Route path="/voucher-request-add" element={<RedirectionComp page={<Voucherrequest />} />} />
        <Route path="/voucher-request" element={<RedirectionComp page={<Voucherrequestlist />} />} />
        <Route path="/credit" element={<RedirectionComp page={<Credit />} />} />
        <Route path="/thankyoupage" element={<RedirectionComp page={<Thankyoupage />} />} />
        <Route path="/useragreement" element={<Useragreement/>} />
        <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
        <Route path="/thankyoupagelogin" element={<Thankyoupagelogin/>} />
        <Route path="/termsconditions" element={<Termsconditions/>} />
        <Route path="/save-cart-list" element={<RedirectionComp page={<SaveCartList />} />} />
        <Route path="/mini/category/:id/:name/:url" element={<RedirectionComp page={<MiniCategory />} bulk={true} />} />
        <Route path="/bulkproductdetails" element={<RedirectionComp page={<BulkProductdetails />} bulk={true} />} />
   
        <Route path="/saved-cart-detail/:orderid" element={<RedirectionComp page={<SavedCartDetails />} />} />
        <Route path="/saved-cart-pay/:orderid" element={<RedirectionComp page={<SaveCartPay />} />} />
      </Routes>
    </div>
  )

}

export default App;
